import React, { useContext } from 'react';

import { FilterButton } from '../../FilterButton';
import DiscoveryContextV2 from '../../../../../contexts/discoveryContext/contextV2';
import ClearFilterButton from '../ClearFilterButton';
import { bold } from './styles.module.css';
import { count } from '../TagValue/styles.module.css';

const distanceDefaultLabel = 'Distance';

const DistanceValueComponent = ({ modalOpen, clearFilter, ...props }) => {
  const {
    filters: {
      distance: { selectedDistances },
    },
  } = useContext(DiscoveryContextV2);

  const sportLabels = selectedDistances.map((n) => n.label);

  const label =
    sportLabels?.length === 1 ? sportLabels[0] : distanceDefaultLabel;
  const sportCount = sportLabels?.length ?? 0;

  return (
    <FilterButton active={sportCount > 0} {...props}>
      <span className={sportCount > 0 ? bold : undefined}>{label}</span>
      {sportCount > 1 && <span className={count}>{sportCount}</span>}
      {sportCount > 0 && <ClearFilterButton onClick={clearFilter} />}
    </FilterButton>
  );
};

export default DistanceValueComponent;
